import BaseSelector from '@src/components/BaseSelector';

import { useDivisionsSelector } from './hooks/useDivisionsSelector';

export const DivisionsSelector = ({
  onChange,
  value = [],
  showAllOption = false,
  mode = 'multiple',
  allValue = [],
  allLabelId = 'divisionSelector.allDivisions',
  disabled = false,
}) => {
  const { items, loading, handlePopupScroll, search, reset } = useDivisionsSelector({});

  return (
    <BaseSelector
      items={items}
      loading={loading}
      handlePopupScroll={handlePopupScroll}
      onSearch={search}
      onReset={reset}
      value={value}
      onChange={onChange}
      mode={mode}
      getItemName={item => item?.name || ''}
      getItemId={item => item.id}
      showAllOption={showAllOption}
      allLabelId={allLabelId}
      allValue={allValue}
      disabled={disabled}
    />
  );
};

export default DivisionsSelector;
